import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {UserService} from '../services/user/user.service';
import {MyCognitoUser} from '../cognito-user-interfaces';
import {InviteControllerService, UserDto} from '@api/utisha-backend';
import UserTypeEnum = UserDto.UserTypeEnum;
import {MessageService} from '../services/message/message.service';
import {getApiErrorMessage} from '../util/api-utils';
import {NavigationService} from '../services/nav/navigation.service';

@Injectable({
  providedIn: 'root'
})
export class StudentGuard  {
  loggedIn: boolean;

  constructor(private userService: UserService,
              private navService: NavigationService,
              private invitationService: InviteControllerService,
              private messageService: MessageService) {
  }

  private checkProfileComplete(user: UserDto, route: RouterStateSnapshot): boolean {
    if (!user.profileComplete && route.url.indexOf('profile') === -1) {
      this.navService.editStudentProfile();
      this.messageService.info('Please complete your profile');
      return false;
    }
    return true;
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const user: UserDto = await this.userService.getUser();
    if (!user) {
      return Promise.resolve(false);
    }
    return Promise.resolve(this.checkProfileComplete(user, state) && user.userType === UserTypeEnum.Student);
  }
}
